module.exports = __webpack_public_path__ + "img/1635580732903508.a052c209.jpg";